
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {abnormalDeliveryOverdelivery, getOverDeliveryList} from "@/api/proforma";
import {Message} from "element-ui";

@Component({
  name: 'ProcessExcessQty',
})
export default class ProcessExcessQty extends Vue {
  @Prop({default: false}) private show: boolean;
  @Prop({default: "标记库存"}) private title: "";
  @Prop({default: ""}) private poInfoId: "";
  @Prop({default: 0}) private remainingMarkQty: 0;
  @Prop({default: []}) private packingList: any[];


  @Watch("show", {immediate: true})
  private async watchData() {
    if (this.show) {
      this.getList()
      this.markQty = this.remainingMarkQty;
    }
  }

  private packings:CustomsPacking[] = [];
  /**
   * 获取可以被标记的主包装
   * @private
   */
  private getList() {
    this.packings = this.packingList ;
  }

  /**
   * 标记库存数量
   * @private
   */
  private markQty = 0;

  private clearMarkQty() {
    this.markQty = 0;
  }

  private close() {
    this.clearMarkQty();
    this.$emit('update:show', false);
  }

  private success() {
    this.close();
    this.$emit('markInventorySuccess');
  }

  /**
   * 标记数量变更时做的处理
   * @param qty
   * @private
   */
  private markQtyChange(qty: string) {
    const pattern = /^\d+$/;
    if (qty &&!pattern.test(qty)) {
      Message.error({
        message: "请输入正整数",
        duration: 2000
      });
      this.clearMarkQty();
    }
    if (Number(qty) > this.remainingMarkQty) {
      this.markQty = this.remainingMarkQty;
    }
    if (Number(qty) < 0) {
      this.clearMarkQty();
    }
  }

  private loading = false;
  /**
   * 调接口处理超发
   * @private
   */
  private async mark() {
    this.loading = true;
    try {
      if (this.markQty && this.markQty !== 0) {
        await abnormalDeliveryOverdelivery(this.poInfoId, this.markQty);
        this.success()
      } else {
        Message.error({
          message:"标记数量 = 0或者不是一个数字 ，无需点击确定。",
          duration:2000
        })
      }
    }catch (error) {
     console.error(error);
    }finally {
      this.loading = false;
    }
  }
}

class CustomsPacking {
  id: string;
  code: string;
  hqPackingListCode: string;
  totalNumberPcs: number;
  inventoryState: string;
  chooseNumberPcs :number;
}

